import { helper } from '@ember/component/helper';
import { assert } from '@ember/debug';

type FiltersortPositionalSignature<Type> = [Type[], string, string];
interface FiltersortNamedSignature {
  eq: string[];
}

export default helper(function filterSort<Type>(
  positional: FiltersortPositionalSignature<Type>,
  named: FiltersortNamedSignature
): Type[] {
  assert(
    `Es wurden nicht 3 Positional Parameter übergeben, sondern ${positional.length} (filter-sort @models "filterAttribute" "sortAttribute")`,
    positional.length == 3
  );
  if (positional.length != 3) {
    return [];
  }

  if (!positional[0] || positional[0].length == 0) {
    return positional[0];
  }
  let accessPathFilter = positional[1];
  const inverseFilter = accessPathFilter?.[0] === '!';
  if (inverseFilter) {
    accessPathFilter = accessPathFilter.slice(1);
  }

  let models = [];
  if (named.eq) {
    if (!Array.isArray(named.eq)) {
      throw new Error('named.eq ist not an array');
    }
    models = positional[0].filter(
      // clever method to invere the filter immitating a XOR with not-eq
      (item) => named.eq.includes(item[accessPathFilter])
    );
  } else {
    models = positional[0].filter(
      // clever method to invere the filter immitating a XOR with not-eq
      (item) => !item[accessPathFilter] != !inverseFilter
    );
  }

  if (!models.length) {
    return [];
  }

  let accessPath = positional[2];
  const desc = accessPath?.[0] === '-';
  if (desc) {
    accessPath = accessPath.slice(1);
  }
  assert(
    `filter-sort: getting \`${accessPath}\` from ${models[0]} is nullish: ${deep_value(models[0], accessPath)}`,
    deep_value(models[0], accessPath)
  );
  const typeOfValue = typeof deep_value(models[0], accessPath);

  if (typeOfValue === 'string') {
    models.sort((a, b) => {
      if (deep_value(a, accessPath)?.localeCompare) {
        return deep_value(a, accessPath)?.localeCompare(
          deep_value(b, accessPath)
        );
      } else {
        const valA = deep_value(a, accessPath)?.toString() || '';
        const valB = deep_value(b, accessPath)?.toString() || '';
        return valA.localeCompare(valB);
      }
    });
    if (desc) {
      models.reverse();
    }
  } else {
    const mult = desc ? -1 : 1;
    models.sort(
      (a, b) => (deep_value(a, accessPath) - deep_value(b, accessPath)) * mult
    );
  }
  // debug

  return models;
});
const deep_value = (obj: any, path: string) =>
  path.split('.').reduce((current, nextPath) => current?.[nextPath], obj);
